import React from "react";

const ProgressBar = ({ profile_percent }) => {
  const getColor = (index) => {
    if (profile_percent === 100) return "bg-green-500"; // All green if 100%
    if (profile_percent >= 75 && index < 3) return "bg-yellow-500"; // First 3 yellow, last gray
    if (profile_percent >= 50 && index < 2) return "bg-yellow-500"; // First 2 yellow, rest gray
    if (profile_percent >= 25 && index == 0) return "bg-red-500"; // Only the first one red
    return "bg-txtGreyDark"; // Default gray for inactive bars
  };

  return (
    <div className="flex gap-1">
      {[0, 1, 2, 3].map((index) => (
        <div
          key={index}
          className="h-[6px] w-full overflow-hidden rounded-lg bg-gray-300"
        >
          <div
            className={`h-full transition-all duration-300 ${getColor(index)}`}
            style={{ width: "100%" }}
          ></div>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
